import { createReducer, on } from '@ngrx/store';
import { ChangePasswordState, initialChangePasswordState } from './state';
import {
  changePassword,
  requestSuccess,
  requestError,
  clearPassword,
} from './actions';

export const changePasswordReducer = createReducer(
  initialChangePasswordState,
  on(changePassword, (state): ChangePasswordState => {
    return { ...state, loading: true };
  }),
  on(requestSuccess, (state, { response }): ChangePasswordState => {
    return {
      error: false,
      loading: false,
      response: response,
    };
  }),
  on(requestError, (state, { error }): ChangePasswordState => {
    return {
      error: error,
      loading: false,
      response: null,
    };
  }),
  on(clearPassword, (state): ChangePasswordState => {
    return {
      error: false,
      loading: false,
      response: null,
    };
  })
);
